/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {CustomAppEvent, navigate, WithEvents} from '@dvrd/dvr-controls';

import React, {PureComponent} from 'react';

import PremiumFeature from './premiumFeature';

interface State {
    active: boolean;
}

export default class PremiumFeatureController extends PureComponent<any, State> {
    private readonly event: CustomAppEvent;

    constructor(props: any) {
        super(props);
        this.event = {eventName: 'onPremiumFeature', handler: this.onActivate};
        this.state = {
            active: false
        };
    }

    onActivate = () => {
        this.setState({active: true});
    };

    onProceed = () => {
        navigate('/instellingen/abonnement');
        this.setState({active: false});
    };

    render = () => {
        const {active} = this.state;
        return (
            <WithEvents events={this.event}>
                <PremiumFeature onProceed={this.onProceed} active={active} />
            </WithEvents>
        );
    };
}
